import { useRef, useState } from 'react';
import api from '../../services/api';
import { resolveMediaUrl } from '../../utils/mediaUrl';

const ACCEPT = 'image/png,image/jpeg,image/jpg,image/webp,.jpg,.jpeg,.png,.webp';

function isAllowedImage(file) {
  if (!file) return false;
  const type = String(file.type || '').toLowerCase();
  if (['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/pjpeg'].includes(type)) return true;
  return /\.(jpe?g|png|webp)$/i.test(file.name || '');
}

export default function GymLogoUpload({ gymId, currentUrl = '', onUploaded }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !gymId) return;
    setError('');
    if (file.size > 2 * 1024 * 1024) {
      setError('El archivo no puede superar 2 MB.');
      return;
    }
    if (!isAllowedImage(file)) {
      setError('Solo PNG, JPG o WEBP.');
      return;
    }
    setUploading(true);
    try {
      const form = new FormData();
      form.append('file', file);
      const res = await api.post(`/gyms/${gymId}/logo`, form);
      const logoUrl = res.data?.logo_url || '';
      onUploaded?.(logoUrl);
      if (logoUrl) {
        window.dispatchEvent(new CustomEvent('gym-brand-updated', {
          detail: { gymId, branding: res.data?.branding || { logo_url: logoUrl } },
        }));
      }
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo subir el logo.');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const preview = resolveMediaUrl(currentUrl);

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-4">
        {preview ? (
          <img
            src={preview}
            alt="Logo"
            className="h-16 w-auto max-w-[160px] object-contain border border-stone-200 rounded-lg p-1 bg-white"
          />
        ) : (
          <div className="h-16 w-16 rounded-lg border border-dashed border-stone-300 flex items-center justify-center text-xs text-stone-500">
            Sin logo
          </div>
        )}
        <div>
          <button
            type="button"
            className="btn-secondary text-sm"
            disabled={uploading || !gymId}
            onClick={() => inputRef.current?.click()}
          >
            {uploading ? 'Subiendo…' : 'Seleccionar archivo'}
          </button>
          <p className="text-xs text-stone-500 mt-1">PNG, JPG o WEBP · máx. 2 MB</p>
        </div>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT}
        className="hidden"
        onChange={handleFile}
      />
      {error ? <p className="text-sm text-red-700">{error}</p> : null}
    </div>
  );
}
